/* JASON BRICKHILL — Zapiet Booster Localization */

(() => {
  const CONFIG = {
    US: { currency: 'USD', locale: 'en-US', price: 30, imperial: true },
    CA: { currency: 'CAD', locale: 'en-CA', price: 30, imperial: true },
    AU: { currency: 'AUD', locale: 'en-AU', price: 50 },
    GB: { currency: 'GBP', locale: 'en-GB', price: 25 },
    UK: { currency: 'GBP', locale: 'en-GB', price: 25 },
    FR: { currency: 'EUR', locale: 'fr-FR', price: 30 },
    DE: { currency: 'EUR', locale: 'de-DE', price: 30 },
    IT: { currency: 'EUR', locale: 'it-IT', price: 30 },
    ES: { currency: 'EUR', locale: 'es-ES', price: 30 },
    NL: { currency: 'EUR', locale: 'nl-NL', price: 30 },
    IE: { currency: 'EUR', locale: 'en-IE', price: 30 },
    PT: { currency: 'EUR', locale: 'pt-PT', price: 30 },
    BE: { currency: 'EUR', locale: 'fr-BE', price: 30 },
    AT: { currency: 'EUR', locale: 'de-AT', price: 30 },
    FI: { currency: 'EUR', locale: 'fi-FI', price: 30 },
    LU: { currency: 'EUR', locale: 'fr-LU', price: 30 },
    CH: { currency: 'CHF', locale: 'de-CH', price: 25 },
    DK: { currency: 'DKK', locale: 'da-DK', price: 200 },
    SE: { currency: 'SEK', locale: 'sv-SE', price: 300 },
    AE: { currency: 'AED', locale: 'ar-AE', price: 130 },
    IN: { currency: 'INR', locale: 'hi-IN', price: 2750 }
  };

  const TEXT = {
    en: {
      title: 'Add a Booster?',
      action: 'Make it Taller',
      cart: '+ Booster:',
      metricTooltip: 'Adds 7 cm in length to any Tee or Tank',
      imperialTooltip: 'Adds 2.75 inches in length to any Tee or Tank'
    },
    fr: {
      title: 'Ajouter un Booster ?',
      action: 'Allonger',
      cart: '+ Booster :',
      metricTooltip: 'Ajoute 7 cm de longueur à tout Tee ou débardeur',
      imperialTooltip: 'Ajoute 2,75 pouces de longueur à tout Tee ou débardeur'
    },
    de: {
      title: 'Booster hinzufügen?',
      action: 'Verlängern',
      cart: '+ Booster:',
      metricTooltip: 'Fügt jedem T-Shirt oder Tanktop 7 cm Länge hinzu'
    },
    es: {
      title: '¿Añadir Booster?',
      action: 'Alargar',
      cart: '+ Booster:',
      metricTooltip: 'Agrega 7 cm de largo a cualquier camiseta o top sin mangas'
    },
    it: {
      title: 'Aggiungere Booster?',
      action: 'Allungare',
      cart: '+ Booster:',
      metricTooltip: 'Aggiunge 7 cm di lunghezza a qualsiasi Tee o Canotta'
    },
    nl: {
      title: 'Booster toevoegen?',
      action: 'Langer maken',
      cart: '+ Booster:',
      metricTooltip: 'Voegt 7 cm lengte toe aan elk T-shirt of tanktop'
    },
    sv: {
      title: 'Lägg till Booster?',
      action: 'Gör längre',
      cart: '+ Booster:',
      metricTooltip: 'Lägger till 7 cm längd på varje T-shirt eller linne'
    },
    da: {
      title: 'Tilføj Booster?',
      action: 'Gør længere',
      cart: '+ Booster:',
      metricTooltip: 'Tilføjer 7 cm længde til enhver T-shirt eller tanktop'
    },
    pt: {
      title: 'Adicionar Booster?',
      action: 'Tornar mais comprido',
      cart: '+ Booster:',
      metricTooltip: 'Adiciona 7 cm de comprimento a qualquer camiseta ou regata'
    },
    ar: {
      title: 'إضافة Booster؟',
      action: 'اجعله أطول',
      cart: '+ Booster:',
      metricTooltip: 'يضيف 7 سم إلى طول أي قميص أو تانك'
    },
    hi: {
      title: 'बूस्टर जोड़ें?',
      action: 'इसे लंबा बनाएं',
      cart: '+ बूस्टर:',
      metricTooltip: 'किसी भी टी या टैंक में 7 सेमी लंबाई जोड़ता है'
    }
  };

  function getCountry() {
    return (window.Shopify?.country || 'US').toUpperCase();
  }

  function getLanguage() {
    return (
      window.Shopify?.locale ||
      document.documentElement.lang ||
      'en'
    ).toLowerCase().split('-')[0];
  }

  function getText() {
    return TEXT[getLanguage()] || TEXT.en;
  }

  function getPrice() {
    const country = getCountry();
    const config = CONFIG[country] || {
      currency: 'USD',
      locale: 'en-US',
      price: 30
    };

    try {
      return new Intl.NumberFormat(config.locale, {
        style: 'currency',
        currency: config.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(config.price);
    } catch (e) {
      return '$30';
    }
  }

  function getTooltip() {
    const country = getCountry();
    const text = getText();

    if (CONFIG[country]?.imperial && text.imperialTooltip) {
      return text.imperialTooltip;
    }

    return text.metricTooltip || TEXT.en.metricTooltip;
  }

  function updateProductPage() {
    const text = getText();
    const price = getPrice();

    document.querySelectorAll('.spb-productdesctextcolor').forEach(el => {
      const current = el.textContent.trim();

      if (
        current === 'Add a Booster?' ||
        Object.values(TEXT).some(t => current === t.title)
      ) {
        if (current !== text.title) {
          el.textContent = text.title;
        }
      }
    });

    document.querySelectorAll('.toggle-label').forEach(label => {
      const original = label.innerHTML;
      let html = original;

      html = html.replace(
        /Make it Tall(?:er)?|Allonger|Verlängern|Alargar|Allungare|Langer maken|Gör längre|Tornar mais comprido|اجعله أطول|इसे लंबा बनाएं/gi,
        text.action
      );

      html = html.replace(/\(\+\s*.*?\)/, `(+ ${price})`);

      if (html !== original) {
        label.innerHTML = html;
      }
    });

    const tooltip = getTooltip();

    document.querySelectorAll('sl-tooltip').forEach(el => {
      if (el.getAttribute('aria-label') !== tooltip) {
        el.setAttribute('aria-label', tooltip);
      }

      if (el.getAttribute('content') !== tooltip) {
        el.setAttribute('content', tooltip);
      }
    });
  }

  function updateCartDrawer() {
    const drawer =
      document.querySelector('#Cart-Drawer.active') ||
      document.querySelector('#Cart-Drawer');

    if (!drawer) return;

    const text = getText();
    const replacement =
      `${text.cart} ${text.action} (+ ${getPrice()})`;

    drawer.querySelectorAll('.product-cart-item-options').forEach(el => {
      const original = el.innerHTML;

      if (!/Add a Booster\?|Make it Tall/i.test(original)) return;

      let html = original;

      html = html.replace(
        /Add a Booster\?.*?(?:Make it Tall(?:er)?)?(?:\s*\(\+.*?\))?/i,
        replacement
      );

      html = html.replace(
        /(?:<br\s*\/?>)?\s*Make it Tall(?:er)?(?:\s*\(\+.*?\))?/gi,
        ''
      );

      if (html !== original) {
        el.innerHTML = html;
      }
    });
  }

  let scheduled = false;

  function update() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      updateProductPage();
      updateCartDrawer();
      scheduled = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  const observer = new MutationObserver(update);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();